/* eslint-disable react/prop-types */
import React, { useState, useMemo, useEffect } from 'react';
import {
  Row,
  Col,
  Spin,
  Form,
  Input,
  DatePicker,
  Card,
  Tabs,
} from 'antd';

import Table from 'components/Table';
import Select from 'components/Select';
import { HistoryOutlined } from '@ant-design/icons';
import SearchControls from 'components/SearchControls';
import { useBitacora } from 'hooks/useBitacora';
import ModalDetallesBitacora from './ModalDetallesBitacora';
import TableBitacoraDescuentos from './TableBitacoraDescuentos';

const Bitacora = () => {
  const [formSearch] = Form.useForm();
  const [openModal, setOpenModal] = useState(false);

  const {
    loading,
    usuarios,
    data,
    selected,
    selectedRowKeys,
    currentPage,
    opcionesPadrones,
    getColumns,
    getAccionesOptions,
    getModalTitleFromSelected,
    wipe,
    handleOnRowClick,
    rowSelection,
    handleSearch,
    handlePageChange,
    setSelected,
  } = useBitacora();

  const baseURI = '/padrones/bitacora-de-padrones/';
  const padronId = Form.useWatch('id_padron', formSearch);

  // eslint-disable-next-line max-len
  const accionesOptions = useMemo(() => getAccionesOptions(padronId), [padronId, getAccionesOptions]);

  useEffect(() => {
    formSearch?.setFieldsValue?.({ accion_inf: undefined });
  }, [padronId, formSearch]);
  const handleFormSearch = async () => {
    try {
      await formSearch.validateFields();
      const formValues = formSearch.getFieldValue();
      await handleSearch(formValues);
    } catch (error) {
      // El error ya se maneja en el hook
    }
  };

  const handleWipe = () => {
    const defaultValues = wipe();
    formSearch.resetFields();
    formSearch.setFieldsValue(defaultValues);
  };

  return (
    <Row align="center" justify="center" className="container">
      <Col span={24}>
        <Card
          className="form-container"
          title="Bitácora de Padrónes"
          bordered={false}
        >
          <Tabs defaultActiveKey="padrones">
            <Tabs.TabPane tab="Bitácora de Padrones" key="padrones">
              <Spin tip="Cargando..." spinning={loading}>
                <Form
                  form={formSearch}
                  layout="vertical"
                  scrollToFirstError
                  onFinish={handleFormSearch}
                  className="without-feedback"
                >
                  <Row gutter={10}>
                    <Col xs={24} sm={24} md={8}>
                      <Form.Item label="Padron" name="id_padron">
                        <Select
                          dataSource={opcionesPadrones}
                          labelProp="descripcion"
                          valueProp="id"
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={8}>
                      <Form.Item label="Usuario" name="usuario_creo">
                        <Select
                          dataSource={usuarios}
                          labelProp="nombre_completo"
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={8}>
                      <Form.Item label="Clave" name="clave">
                        <Input />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={8}>
                      <Form.Item label="Fecha inicio" name="fecha_inicio">
                        <DatePicker showTime style={{ width: '100%' }} />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={8}>
                      <Form.Item label="Fecha fin" name="fecha_fin">
                        <DatePicker showTime style={{ width: '100%' }} />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={8}>
                      <Form.Item
                        label="Acción"
                        name="accion_inf"
                        rules={[
                          {
                            required: padronId === 'TRAMITES',
                            message: 'La acción es requerida para Trámites',
                          },
                        ]}
                      >
                        <Select
                          dataSource={accionesOptions}
                          labelProp="descripcion"
                          valueProp="id"
                          allowClear
                        />
                      </Form.Item>
                    </Col>

                    <SearchControls
                      onSearch={handleFormSearch}
                      onClear={handleWipe}
                      searchLoading={loading}
                    />
                  </Row>
                </Form>

                <Table
                  cols={getColumns()}
                  data={data.results}
                  count={data.count}
                  rowSelection={rowSelection}
                  rowKey="id"
                  handleOnRowClick={handleOnRowClick}
                  currentPage={currentPage}
                  customActions={[
                    {
                      text: 'Historial',
                      icon: <HistoryOutlined />,
                      tooltip: 'Ver historial',
                      disabledBySelection: true,
                      onClick: () => {
                        const rec = data.results.find((r) => r.id === selectedRowKeys[0]);
                        if (!rec) return;
                        setSelected(rec);
                        setOpenModal(true);
                      },
                    },
                  ]}
                  pageSize={10}
                  pagination={false}
                  baseURI={baseURI}
                  paginationCallback={handlePageChange}
                />

                <ModalDetallesBitacora
                  visible={openModal}
                  onClose={() => setOpenModal(false)}
                  titulo={getModalTitleFromSelected()}
                  inicial={selected?.data_anterior || {}}
                  final={selected?.data_nueva || {}}
                  ordenDePago={selected?.orden_de_pago || {}}
                  salida={selected?.data_salida || {}}
                />
              </Spin>
            </Tabs.TabPane>

            <Tabs.TabPane tab="Bitacora de movimientos" key="descuentos">
              <TableBitacoraDescuentos />
            </Tabs.TabPane>
          </Tabs>
        </Card>
      </Col>
    </Row>
  );
};

export default Bitacora;
